export default __webpack_public_path__ + "static/media/mobile.3daa5e4e.svg";